import { getClientId } from "@/data/repository/ClientRepository";
import { storage } from "@/main";

export async function uploadPdfDocument(
  fileName: string,
  pdfDocument: File
) {
  try {
    const storageLocation = `projectDocuments/${getClientId()}/${fileName}`;
    const ref = storage.ref(storageLocation);
    
    const uploadTask = await ref.put(pdfDocument);
    await uploadTask.ref.getDownloadURL();

    return true;
  } catch (error) {
    return false;
  }
}

export async function getPdfDocument(
  fileName: string
) {
  const storageLocation = `projectDocuments/${getClientId()}/${fileName}`;
  try {
    const url = await storage.ref(storageLocation).getDownloadURL();
    return url;
  } catch (error) {
    return null;
  }
}